import { createFileRoute } from "@tanstack/react-router";
import { OwnershipScreen } from "../components/relations/OwnershipScreen";

export const Route = createFileRoute("/_auth/relations/ownership")({
  staticData: {
    titleKey: "relations.ownership.title",
    breadcrumbKey: "breadcrumb.operate",
    breadcrumbN: 7,
  },
  component: OwnershipScreen,
});
